<template>
  <hello-world />
</template>

<script>
import Task_manager from "../components/task_manager";

export default {
  name: "Home",

  components: {
    Task_manager,
  },
};
</script>
